import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, ActivatedRoute } from '@angular/router';
import { Observable, of } from 'rxjs';
import { AuthenticationService } from '../services/authentication.service';
import jwt_decode from "jwt-decode";


@Injectable({
  providedIn: 'root'
})
export class AuthGuard {

  constructor(private activatedRouter: ActivatedRoute, private router: Router, private authenticationService: AuthenticationService) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot) {
    this.authenticationService.check().subscribe(
      (data) => {
        if (!data.success) {
          this.router.navigate(['/']);
          return false;
        }

        return true;
      },
      (error) => {
        this.router.navigate(['/']);

        return false;
      }
    )
  }
}
